import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@mui/styles";
import {FormattedMessage, injectIntl} from "react-intl";
import { Button, Avatar } from "@mui/material"
import { BeatLoader } from 'react-spinners';

import showStyle from "assets/jss/views/picking/order/showStyle";
import { capitalize } from "utils/capitalize";
import { assign } from "actions/order/update";

function Runner({ classes, assign, runnerExists, lineItems, member, updateLoadingOrder }) {

    const runnerList = [];

    function renderRunnerAvatar(runner, key) {
        return (
            runner.user.picture ?
                <img
                    src={runner.user.picture}
                    className={classes.img}
                    alt={""}
                    key={key}
                    style={{position: 'relative', zIndex: 20 - key}}
                /> :
                <Avatar className={classes.imgPlaceholder} key={key} style={{position: 'relative', zIndex: 20 - key}}>
                    {capitalize(runner.user.givenName.charAt(0))}
                </Avatar>
        );
    };

    function isThereOtherRunnerThanUser(lineItems, member) {
        for (let i = 0; i < lineItems.length; i++) {
            if (lineItems[i].runner === null || lineItems[i].runner["@id"] !== `/members/${member.id}`) {
                return true
            }
        }

        return false;
    }

    function handleClickAssign(orderId, runner) {
        assign(orderId, {"runner": runner})
    };

    function renderRunnner() {
        if (runnerExists === false) {
            return null;
        }

        return (
            <div className={classes.runnerList}>
                <span className={classes.affectedTo}>
                    <FormattedMessage id={"picking.order.show.header.affectedTo"}/>
                </span>
                {lineItems.map((item, key) => {
                    if (item.runner !== null) {
                        if (!runnerList.includes(item.runner["@id"])) {
                            runnerList.push(item.runner["@id"]);
                            return renderRunnerAvatar(item.runner, key);
                        }
                    }

                    return null;
                })}
            </div>
        );
    }

    function renderOtherRunners() {
        if (isThereOtherRunnerThanUser(lineItems, member) === false) {
            return null;
        }

        return (
            <Button
                color="primary"
                variant="contained"
                onClick={() => handleClickAssign(lineItems[0].order["@id"], member.id)}
                classes={{root: classes.assign}}
            >
                <FormattedMessage id={"picking.order.show.header.assignItToMe"}/>
                <div className={classes.submitLoading}>
                    <BeatLoader
                        sizeUnit={"px"}
                        size={4}
                        color={"#FFF"}
                        loading={updateLoadingOrder}
                    />
                </div>
            </Button>
        );
    }

    return (
        <div className={classes.runner}>
            {renderRunnner()}
            {renderOtherRunners()}
        </div>
    );
}

function mapStateToProps(state) {
    return {
        updateLoadingOrder: state.order.update.loading,
        member: state.authentication.member,
    };
};

const mapDispatchToProps = dispatch => ({
    assign: (orderId, data) => dispatch(assign(orderId, data)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(showStyle)(injectIntl(Runner)));
